import { atomWithReset } from "jotai/utils";
export const loaderAtom = atomWithReset(false)